import {Nullable} from "@data-force/app";
import {Selector} from "./selectorType";
import StoreState from "../../interfaces/store/storeState";
import {JobEntity, PhaseConfigNormalized} from "../../interfaces/store/actions/payload/job";

const selectSelectedJob: Selector<Nullable<JobEntity>> = (({job: {selectedJob}}: StoreState): Nullable<JobEntity> => selectedJob);

const selectPhaseConfigList: Selector<PhaseConfigNormalized> = (
    ({job: {phaseConfigList}}: StoreState): PhaseConfigNormalized => phaseConfigList);

export {
    selectSelectedJob,
    selectPhaseConfigList,
};
